import { Component, Input } from '@angular/core';

@Component({
  selector: 'question-text',
  template: `
    <label for="{{ componentId }}" class="label-basic__text {{ inputClass }}" [innerHTML]="displayText"></label>
  `,
})
export class QuestionTextComponent {
  @Input() displayText: string;
  @Input() inputClass: string;
  @Input() componentId: string;
}
